import React from 'react';
import { Input, Label, Select_simple } from "./ui";

const TabF_Diagnostico = ({ data = {}, onChange }) => {

	const handleChange = (e) => {
		const { name, value } = e.target;
		onChange({ ...data, [name]: value });
	};

	const handleCheck = (e) => {
		const { name, checked } = e.target;
		onChange({ ...data, [name]: checked });
	};

	return (
		<div className="space-y-10 p-2">

			{/* BLOQUE 1: ASISTENCIA ESTATAL */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					1. Asistencia estatal
				</h3>
				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200 space-y-6">
					<Label className="font-bold text-slate-700">
						¿Recibe actualmente apoyo estatal? (Marcar los que correspondan)
					</Label>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
						{['Provincial', 'Municipal', 'Nacional'].map(nivel => (
							<div key={nivel} className="space-y-2 p-4 bg-white rounded-lg border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
								<div className="flex items-center space-x-3">
									<input
										type="checkbox"
										id={`apoyo_${nivel.toLowerCase()}`}
										name={`apoyo_${nivel.toLowerCase()}`}
										checked={!!data[`apoyo_${nivel.toLowerCase()}`]}
										onChange={handleCheck}
										className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 cursor-pointer"
									/>
									<Label htmlFor={`apoyo_${nivel.toLowerCase()}`} className="text-sm font-bold cursor-pointer uppercase">
										Apoyo {nivel}
									</Label>
								</div>

								{/* Detalle condicional si marca el checkbox */}
								{data[`apoyo_${nivel.toLowerCase()}`] && (
									<div className="mt-2 animate-in slide-in-from-top-1">
										<Input
											name={`apoyo_${nivel.toLowerCase()}_detalle`}
											placeholder={`Nombre del programa ${nivel}...`}
											value={data[`apoyo_${nivel.toLowerCase()}_detalle`] || ''}
											onChange={handleChange}
										/>
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</section>

			{/* BLOQUE 2: NECESIDADES */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					2. >Necesidades
				</h3>
				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
					<Label className="font-bold text-slate-700 mb-4 block">
						Indique las áreas donde la institución requiere mayor apoyo o regularización:
					</Label>

					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
						{[
							{ id: 'nec_infra', label: 'Infraestructura deportiva' },
							{ id: 'nec_dominio', label: 'Regularización dominial' },
							{ id: 'nec_equip', label: 'Equipamiento deportivo' },
							{ id: 'nec_iluminacion', label: 'Iluminación' },
							{ id: 'nec_edilicia', label: 'Mejoras edilicias' },
							{ id: 'nec_capa', label: 'Capacitación' },
							{ id: 'nec_inst', label: 'Fortalecimiento institucional' },
							{ id: 'nec_planos', label: 'Regularización de planos' },
							{ id: 'nec_habil', label: 'Habilitación instalaciones' },
							{ id: 'nec_otros_check', label: 'Otros requerimientos...' },
						].map(item => (
							<div key={item.id} className="flex items-center space-x-3 p-2 bg-white rounded-md border border-slate-100 shadow-sm hover:bg-blue-50 transition-colors">
								<input
									type="checkbox"
									id={item.id}
									name={item.id}
									checked={!!data[item.id]}
									onChange={handleCheck}
									className="w-4 h-4 rounded text-blue-600 focus:ring-blue-500 cursor-pointer"
								/>
								<Label htmlFor={item.id} className="text-[13px] text-slate-700 cursor-pointer font-medium leading-tight">
									{item.label}
								</Label>
							</div>
						))}
					</div>

					{/* Opción Otros: Siguiendo el mismo criterio del TabE */}
					{data.nec_otros_check && (
						<div className="mt-4 p-4 bg-white rounded-lg border border-blue-100 animate-in slide-in-from-top-2">
							<Label className="text-xs font-bold text-blue-600 mb-1 block">Especifique otros requerimientos:</Label>
							<Input
								name="nec_otros_detalle"
								placeholder="Detalle sus necesidades específicas..."
								value={data.nec_otros_detalle || ''}
								onChange={handleChange}
							/>
						</div>
					)}
				</div>
			</section>

		</div>
	);
};

export default TabF_Diagnostico;